// src/components/module/ventas/CompletarVentaPendienteWrapper.tsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import { CompletarVentaPendiente } from './CompletarVentaPendiente';
import PageLayout from '../../../components/layout/PageLayout';
import PaymentIcon from '@mui/icons-material/Payment';

const CompletarVentaPendienteWrapper: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const numeroFactura = searchParams.get('id');

  return (
    <PageLayout icon={PaymentIcon} title="Completar Venta Pendiente">
      <CompletarVentaPendiente numeroFactura={numeroFactura} />
    </PageLayout>
  );
};

export default CompletarVentaPendienteWrapper;